
import React from 'react';
const SvgCom = ({ width, height, size='16', Svg, className = '', onClick, ...otherProps}) => (
  <Svg className={className} width={ width || size} height={ height || size} {...otherProps} onClick={onClick}/>
);

export default SvgCom;